import { Component, OnInit, Input, OnChanges, SimpleChanges, ViewChild, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { NgbModal,ModalDismissReasons, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-info-icon',
  templateUrl: './info-icon.component.html',
  styleUrls: ['./info-icon.component.scss']
})
export class InfoIconComponent implements OnInit , OnChanges,AfterViewInit{

  @Input()info:any="";
  @Input() autoTrigger:boolean;
  modalRef: NgbModalRef;
  helpdocStatus :boolean = false;
  docUrl: any;
  helpdocFullView: boolean;
  @Output() close = new EventEmitter();
  @ViewChild("helpGuide", { static: false }) helpGuide:any;

  constructor(private modalService: NgbModal,private sanitizer:DomSanitizer) {
    this.docUrl =  this.sanitizer.bypassSecurityTrustResourceUrl(environment.doc_url+'/')
   }
  ngAfterViewInit(): void {
   
    if (this.autoTrigger){
      this.open(this.helpGuide)

    }
  
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.docUrl =  this.sanitizer.bypassSecurityTrustResourceUrl(environment.doc_url+'/'+this.info)

  }

  ngOnInit() {
   
    setTimeout(() => {
      this.docUrl =  this.sanitizer.bypassSecurityTrustResourceUrl(environment.doc_url+'/'+this.info)
    },100)
  }
  


  open(content) {

    this.modalRef = this.modalService.open(content, { size: 'lg',windowClass: 'help-guide-modal'});
    
    this.helpdocStatus = false;
    
  }
  //minimize help doc modal
  minimizeHelpDoc(){
    this.helpdocStatus = !this.helpdocStatus;
    this.modalRef.close();
  }

  maximizeHelpDoc(){
    this.helpdocFullView = !this.helpdocFullView;
    const element = document.querySelector(".help-guide-modal");
    if(this.helpdocFullView){
      element.classList.add("max-help-guide-modal");
    }else{
      element.classList.remove("max-help-guide-modal");
    }
  }


  closeHelpBlock(){
    this.helpdocStatus = false;
    this.close.emit(true);
  }
}
